import { render, staticRenderFns } from "./SaleInfoPopup.vue?vue&type=template&id=0648e7a2&"
import script from "./SaleInfoPopup.vue?vue&type=script&lang=js&"
export * from "./SaleInfoPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports